<template>
  <div class="pop-dim">
    <div class="pop-wrap">
      <h2>{{text[type].title}}</h2>
      <p v-html="text[type].desc">
      </p>
      <button-item :btnText="'취소'" :btnClass="'layerpop-btn'" @click="onCancel"/>
      <button-item :btnText="'확인'" :btnClass="'layerpop-btn clear'" @click="onSubmit"/>
      <div class="pop-close"></div>
    </div>
  </div>
</template>

<script>
import ButtonItem from '@/components/ui/button'

export default {
  name: 'LinkLayerPop',
  props: {
    type: {
      type: String,
      default: 'delete' // delete, stop, confirm
    }
  },
  components: {
    ButtonItem
  },
  created () {

  },
  destroyed () {
  },
  methods: {
    onCancel () {
      this.$close(false)
    },
    onSubmit () {
      this.$close(true)
    }
  },
  computed: {},
  data () {
    return {
      text: {
        delete: {
          title: 'UT 삭제 확인',
          desc: '삭제된 UT는 복구가 불가합니다.<br>UT를 삭제하시겠습니까?'
        },
        confirm: {
          title: 'UT 배포 확인',
          desc: '배포된 UT는 수정이 불가합니다.<br>UT링크를 배포하시겠습니까?'
        },
        stop: {
          title: 'UT 배포 중단',
          desc: '배포된 UT의 접근을 제한합니다.<br>UT링크의 배포를 중단하시겠습니까?'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 430px;
  height: 295px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  padding: 0 30px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    color: #444;
    margin: 50px 0 14px;
    padding-top: 65px;
    background: url('../../assets/images/icon-distribution-clear.svg') no-repeat center top;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
    color: #2f2f2f;
    margin-bottom: 40px;
  }
}
</style>
